var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22 12.5537C22 18.0767 17.523 22.5537 12 22.5537C6.477 22.5537 2 18.0767 2 12.5537C2 7.03171 6.477 2.55371 12 2.55371C17.523 2.55371 22 7.03171 22 12.5537Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10.0538H12.1665V10.5538H13.5V11.0539H12.1665V11.5539H13.5V12.0538H12.1665V12.5538H13.5C13.5 13.0881 13.2919 13.5903 12.9142 13.9681C12.5363 14.3459 12.0342 14.5539 11.4999 14.5539C10.9658 14.5539 10.4635 14.3458 10.0857 13.9681C9.70783 13.5903 9.49991 13.0881 9.49991 12.5538H10.8333V12.0538H9.49991V11.5539H10.8333V11.0539H9.49991V10.5538H10.8333V10.0538H9.49991C9.49991 9.5196 9.70796 9.01736 10.0857 8.63952C10.4635 8.26168 10.9656 8.05375 11.4999 8.05375C12.0342 8.05375 12.5363 8.26181 12.9142 8.63952C13.292 9.01736 13.5 9.5196 13.5 10.0538ZM11.4999 7.55371C10.1192 7.55371 9 8.67288 9 10.0538V12.5537C9 13.8502 9.98663 14.9159 11.25 15.0414V17.0537H10.0833V17.5537H12.9166V17.0537H11.75V15.0414C13.0135 14.9159 14 13.8502 14 12.5537V10.0538C14 8.67288 12.8808 7.55371 11.4999 7.55371Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.a3ab5284439773fe3ccdd3089b24ada3.svg";
export { ForwardRef as ReactComponent };